import { type Dayjs } from "dayjs"

const MIN_PADDING_DAYS = 2
const MAX_PADDING_DAYS = 7

// The dates the chart's axis spans: the schedule plus a little padding each
// side, widened to include today. Pure so the padding rule can be pinned
// without laying out a chart.
export function ganttTimelineRange(
  starts: Dayjs[],
  ends: Dayjs[],
  today: Dayjs
): { start: Dayjs; end: Dayjs } {
  const start = starts.reduce((a, b) => (b.isBefore(a) ? b : a))
  const end = ends.reduce((a, b) => (b.isAfter(a) ? b : a))
  // ~7% padding each side rather than a fixed number of days, so a short
  // project doesn't get padded out of proportion — but never more than a
  // week: uncapped, a 30-month project opened on two empty months before its
  // first bar and looked like it had none (EAD-1389 item 2). Under ~100 days
  // the 7% is below the cap, so short projects pad exactly as before.
  const spanDays = end.diff(start, "day") + 1
  const paddingDays = Math.min(
    MAX_PADDING_DAYS,
    Math.max(MIN_PADDING_DAYS, Math.round(spanDays * 0.07))
  )
  const paddedStart = start.subtract(paddingDays, "day")
  const paddedEnd = end.add(paddingDays, "day")
  // Today is date-based only, independent of the schedule — if it falls
  // outside the padded schedule range, expand to include it rather than
  // leaving the indicator unable to render at all.
  return {
    start: today.isBefore(paddedStart) ? today : paddedStart,
    end: today.isAfter(paddedEnd) ? today : paddedEnd
  }
}
